import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './RENT_Lifecycle_Milestone.css';

const RENT_Lifecycle_Milestone = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"RENT_LIFECYCLE_MILESTONE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	RENT_LIFECYCLE_MILESTONE:-1
  });


  const [RENT_LIFECYCLE_MILESTONE, setRENT_LIFECYCLE_MILESTONE] = React.useState(null);
  const [RENT_LIFECYCLE_MILESTONE_D, setRENT_LIFECYCLE_MILESTONE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Token Lifecycle Milestone');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewRENT_LIFECYCLE_MILESTONE(clientInfo,"OpenNew");

		navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutRENT_LIFECYCLE_MILESTONE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostRENT_LIFECYCLE_MILESTONE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewRENT_LIFECYCLE_MILESTONE(clientInfo,"OpenNew");
		}
		navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
		if(Temp_Data2.status!="New"){
			handleDeleteRENT_LIFECYCLE_MILESTONE(Temp_Data2);
			navigate('/RENT_Lifecycle_Milestone#New',{replace:true});
		} 
		else 
			navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lifecycle_Milestone',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!RENT_LIFECYCLE_MILESTONE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [RENT_LIFECYCLE_MILESTONE]) ;


  
  
  var Ids = [];
  for(var Ele in RENT_LIFECYCLE_MILESTONE){
	  for(var Sec in RENT_LIFECYCLE_MILESTONE[Ele]){
		if(Sec == "id")
			Ids.push(RENT_LIFECYCLE_MILESTONE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(RENT_LIFECYCLE_MILESTONE[Ele]["status"]);
		else if(Array.isArray(RENT_LIFECYCLE_MILESTONE[Ele][Sec]))
			  for(var Row in RENT_LIFECYCLE_MILESTONE[Ele][Sec])  // Convert to RENT_LIFECYCLE_MILESTONE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in RENT_LIFECYCLE_MILESTONE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["RENT_LIFECYCLE_MILESTONE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewRENT_LIFECYCLE_MILESTONE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LIFECYCLE_MILESTONE`).then((response1) => {
		if(!RENT_LIFECYCLE_MILESTONE) 
			setRENT_LIFECYCLE_MILESTONE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LIFECYCLE_MILESTONE_D`).then((response2) => {
			setRENT_LIFECYCLE_MILESTONE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddRENT_LIFECYCLE_MILESTONE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewRENT_LIFECYCLE_MILESTONE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LIFECYCLE_MILESTONE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setRENT_LIFECYCLE_MILESTONE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataRENT_LIFECYCLE_MILESTONE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LIFECYCLE_MILESTONE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutRENT_LIFECYCLE_MILESTONE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LIFECYCLE_MILESTONE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostRENT_LIFECYCLE_MILESTONE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LIFECYCLE_MILESTONE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteRENT_LIFECYCLE_MILESTONE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LIFECYCLE_MILESTONE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["1"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("1","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["1"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("1","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["1"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("1","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["1"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("1","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  

const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["1"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_4"]=value;
	Form_Data_onChange("1","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_4",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
  }; 
  

    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["1"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("1","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["2"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0"]=value;
	Form_Data_onChange("2","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0",value,Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
  }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["2"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1"]=value;
	Form_Data_onChange("2","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1",value,Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
  }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["2"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2"]=value;
	Form_Data_onChange("2","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2",value,Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
  }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["2"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3"]=value;
	Form_Data_onChange("2","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3",value,Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
  }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["3"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("3","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["3"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("3","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  

const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["4"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_0"]=value;
	Form_Data_onChange("4","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_0",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
  }; 
  


const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["9"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_0",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
  }; 
  

    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["9"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("9","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["9"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("9","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["9"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("9","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  
    
const RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
	Temp_Data["9"]["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4"]=value;
	//handleAddRENT_LIFECYCLE_MILESTONE(Temp_Data,App_Data['RENT_LIFECYCLE_MILESTONE']);
	Form_Data_onChange("9","RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4",value,Temp_Data);
 	//handleLastDataRENT_LIFECYCLE_MILESTONE(Temp_Data);
    setRENT_LIFECYCLE_MILESTONE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!RENT_LIFECYCLE_MILESTONE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedRENT_LIFECYCLE_MILESTONE =JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
  updatedRENT_LIFECYCLE_MILESTONE[Sec] = [...updatedRENT_LIFECYCLE_MILESTONE[Sec], newRow];
  setRENT_LIFECYCLE_MILESTONE(updatedRENT_LIFECYCLE_MILESTONE);
};

const handleDeleteRow = (sec,index) => {
  const updatedRENT_LIFECYCLE_MILESTONE = JSON.parse(JSON.stringify(RENT_LIFECYCLE_MILESTONE));
  updatedRENT_LIFECYCLE_MILESTONE[sec].splice(index, 1);
  setRENT_LIFECYCLE_MILESTONE(updatedRENT_LIFECYCLE_MILESTONE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Rental Income Token Lifecycle Milestone`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Income Token Milestone ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Milestone ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0" type="text" className="form-control" placeholder="RENT Milestone ID" value={RENT_LIFECYCLE_MILESTONE["1"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Milestone ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1" type="text" className="form-control" placeholder="Asset ID" value={RENT_LIFECYCLE_MILESTONE["1"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2" type="text" className="form-control" placeholder="Offering ID" value={RENT_LIFECYCLE_MILESTONE["1"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3" type="text" className="form-control" placeholder="Milestone Name" value={RENT_LIFECYCLE_MILESTONE["1"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Milestone Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Milestone Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_4"  value={RENT_LIFECYCLE_MILESTONE["1"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_4`]} onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_4_Change} className="form-control" name="Milestone Type"  >
						  <option value="Legal">Legal</option>
						  <option value="Funding">Funding</option>
						  <option value="Construction">Construction</option>
						  <option value="Inspection">Inspection</option>
						  <option value="Rental Operations">Rental Operations</option>
						  <option value="Valuation">Valuation</option>
						  <option value="Distribution">Distribution</option>
						  <option value="Exit">Exit</option>
						  <option value="Auction">Auction</option>
						  <option value="Compliance">Compliance</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Milestone Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone Order`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5" type="text" className="form-control" placeholder="Milestone Order" value={RENT_LIFECYCLE_MILESTONE["1"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Milestone Order`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Planned Start Date`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Planned Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0" type="date"  value={RENT_LIFECYCLE_MILESTONE["2"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0`]} 
							onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0_Change} style={{ borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Planned Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Planned End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1" type="date"  value={RENT_LIFECYCLE_MILESTONE["2"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1`]} 
							onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1_Change} style={{ borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Planned End Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Actual Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2" type="date"  value={RENT_LIFECYCLE_MILESTONE["2"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2`]} 
							onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2_Change} style={{ borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_2"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Actual Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Actual End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3" type="date"  value={RENT_LIFECYCLE_MILESTONE["2"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3`]} 
							onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3_Change} style={{ borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_2_3"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Actual End Date
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Required Completion Percentage`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Required Completion Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0" type="text" className="form-control" placeholder="Required Completion Percentage" value={RENT_LIFECYCLE_MILESTONE["3"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Required Completion Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Completion Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1" type="text" className="form-control" placeholder="Current Completion Percentage" value={RENT_LIFECYCLE_MILESTONE["3"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Current Completion Percentage`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Milestone Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Milestone Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_0"  value={RENT_LIFECYCLE_MILESTONE["4"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_0`]} onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_4_0_Change} className="form-control" name="Milestone Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Submitted for Inspection">Submitted for Inspection</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Released">Released</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Milestone Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_0"  value={RENT_LIFECYCLE_MILESTONE["9"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_0`]} onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1" type="text" className="form-control" placeholder="Created By" value={RENT_LIFECYCLE_MILESTONE["9"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2" type="text" className="form-control" placeholder="Created At" value={RENT_LIFECYCLE_MILESTONE["9"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3" type="text" className="form-control" placeholder="Updated By" value={RENT_LIFECYCLE_MILESTONE["9"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4" type="text" className="form-control" placeholder="Updated At" value={RENT_LIFECYCLE_MILESTONE["9"][`RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4`]} 
						onChange={RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_06_ASSET_MANAGER_LIFECYCLE_EXIT_RENT_LIFECYCLE_MILESTONE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default RENT_Lifecycle_Milestone;  